<template>
  <div class="content-wrapper place-order-wrapper">
    <div class="wrapper place-order">
      <h2 class="mt-0 mb-1">Dine valgte produkter</h2>

      <div
        v-if="isCartCalculating"
        class="loading-overlay">
        <div class="loader">
          <span>Indlæsning af data&hellip;</span>
        </div>
      </div>
      <div
        v-else-if="isCartCalculatingError"
        class="alert alert-danger mx-auto my-auto px-5">
        Fejl ved indlæsning af data.
      </div>
      <template v-else>
        <div class="wardrobe-list">
          <div
            v-for="wardrobe in wardrobeList"
            :key="wardrobe.id"
            class="wardrobe-item"
            :class="{ 'is-active': wardrobe.id === activeWardrobeId }" >

            <wardrobe-summary
              :wardrobe-data="wardrobe"
              :is-collapsible="true"
              :is-remove-enabled="wardrobeList.length > 0"
              @edit="handleEdit"
              @remove="handleRemove"
              @show-gallery="handleShowGallery" />
          </div>
        </div>

        <div class="flex flex-justify-content-end">
          <c-button
            theme="primary"
            class=""
            :is-small="true"
            @click.prevent="handleAddNextWardrobe">
            Tilføj nyt
          </c-button>
        </div>
        <hr class="my-2">
        <p class="flex">
          <strong class="mr-2">Produktets pris</strong>
          <span class="ml-auto">{{ getPriceFormatted(cartTotalPrice) }}</span>
        </p>
      </template>
    </div>
    <div class="navigation-buttons flex mt-auto">
      <c-button
        v-if="wardrobeList.length === 1"
        theme="secondary"
        @click.prevent="goBack(wardrobeList[0].id)">
        Tilbage
      </c-button>
      <c-button
        theme="warning"
        :class="{'full-width': wardrobeList.length > 1}"
        :disabled="!isCartReadyForCheckout"
        @click.prevent="goNext">
        Bestil og betal
      </c-button>
    </div>

    <transition name="fade">
      <c-modal
        v-if="isGalleryVisible"
        :class="{ 'is-visible': isGalleryVisible, 'is-narrow is-centered image-gallery-modal': true }"
        :isPersistent="false"
        :is-visible="isGalleryVisible"
        @close="isGalleryVisible = false">
        <c-modal-header class="text-center">
          Visualisering
        </c-modal-header>
        <c-modal-body>
          <div v-if="currentGalleryImages.length > 1" class="gallery-tabs">
            <button
              v-for="(img, index) in currentGalleryImages"
              :key="index"
              :class="{ active: activeIndex === index }"
              @click="activeIndex = index" >
              {{ img.label }}
            </button>
          </div>

          <div class="image-container">
            <img
              v-for="(image, imageIndex) in currentGalleryImages"
              v-show="imageIndex === activeIndex"
              :key="'image-' + imageIndex"
              :src="image.src"
              alt="Visualisering" />
          </div>
        </c-modal-body>
      </c-modal>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import CustomDecimals from '@/utils/CustomDecimals.js';
import WardrobeSummary from '@/components/layout/WardrobeSummary.vue';

export default {
  name: 'order-summary',
  components: {
    'wardrobe-summary': WardrobeSummary,
  },
  computed: {
    ...mapGetters('cart', [
      'wardrobeList',
      'activeWardrobeId',
      'cartTotalPrice',
      'isCartCalculating',
      'isCartCalculatingError',
      'isCartReadyForCheckout'
    ])
  },
  data () {
    return {
      activeIndex: 0,
      currentGalleryImages: [],
      isGalleryVisible: false
    }
  },
  mounted () {
    this.refreshAllCartPrices();
  },
  methods: {
    ...mapActions('cart', [
      'initNewWardrobe',
      'editExistingWardrobe',
      'removeWardrobe',
      'refreshAllCartPrices'
    ]),
    goNext () {
      this.$router.push({ name: 'placeOrder' });
    },
    goBack (wardrobeId) {
      this.editExistingWardrobe(wardrobeId);
      if (this.$store.getters['creator/hasInventory']) {
        this.$router.push({
          name: 'wardrobeInventory',
          query: {
            wardrobeSummary: true
          }
        });
        return;
      }

      this.$router.push({ name: 'wardrobeDoorsMaterial' }, { query: { wardrobeSummary: true } });
    },
    getPriceFormatted (price) {
      return CustomDecimals.getPriceFormatted(price);
    },
    handleAddNextWardrobe () {
      this.initNewWardrobe();
      this.$router.push({ name: 'startScreen' });
    },
    handleEdit (id) {
      this.editExistingWardrobe(id);
      // Start from second step. If user wants completely different wardrobe a new one should be created
      this.$router.push({ name: 'wardrobeDimensions' });
    },
    handleRemove (id) {
      Vue.swal({
        title: 'Er du sikker på, at du vil slette garderobeskabet?',
        text: 'Denne handling kan ikke fortrydes',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nej',
        showCloseButton: false,
        showLoaderOnConfirm: true,
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.removeWardrobe(id);
        }
      })
    },
    handleShowGallery (images) {
      this.activeIndex = 0;
      this.currentGalleryImages = images;
      this.isGalleryVisible = true;
    },
    handleCloseGallery () {
      this.isGalleryVisible = false;
    }
  }
}
</script>

